module.exports = __webpack_public_path__ + "img/newswiper_7.b1fcefd2.png";